module.exports = __webpack_public_path__ + "static/media/Anova-Regular.c92b56cc.woff2";